import * as Yup from "yup";

// Strict email regex - only allows alphanumeric, dots, underscores, plus, and hyphens
const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const customerDetailSchema = Yup.object().shape({
    firstName: Yup.string()
        .trim()
        .required("This field is required!")
        .max(50, "Cannot be longer than 50 characters!"),
    lastName: Yup.string()
        .trim()
        .required("This field is required!")
        .max(50, "Cannot be longer than 50 characters!"),
    phoneNumber: Yup.string().trim().required("This field is required!"),
    email: Yup.string()
        .trim()
        .required("This field is required!")
        .matches(emailRegex, "Please enter a valid email address")
        .max(255, "Cannot be longer than 255 characters!"),
    dateOfBirth: Yup.string().trim().required("This field is required!"),
    postalCode: Yup.string()
        .trim()
        .required("This field is required!")
        .max(255, "Cannot be longer than 255 characters!"),
    countryCode: Yup.string().trim().required("This field is required!"),
});
